import { findArray } from 'helpers/utils'
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import { useGetEventUnits } from 'helpers/commonCodes';



export function useEventUnit() {
    //const { mirs_competition, mirs_language } = useUrlFriendlyToParameters()
    const params = useUrlFriendlyToParameters()
    let paramsURL = { ...params }
    const data = useGetEventUnits(paramsURL);
    return function (code, isShortDescription) {

        const _isShortDescription = isShortDescription || false // default value to false
        const filter = {
            code: [code]
        }
        const element = findArray(data?.eventUnits, filter)
        const description = element ? element?.description : "-";
        const shortDescription = element ? element?.shortDescription : "-";
        const resp = _isShortDescription
            ? shortDescription
            : description
        return (resp);
    }
}